import { useState } from 'react';
import { demoStreams, demoNfts, demoDrops } from '../services/demoData';
import StreamCard from '@/components/streams/StreamCard';
import DropCard from '@/components/drops/DropCard';
import NFTCard from '@/components/nfts/NFTCard';
import { motion, AnimatePresence } from 'framer-motion';
import { FiVideo, FiPackage, FiImage } from 'react-icons/fi';

export default function ExplorePage() {
  const [activeTab, setActiveTab] = useState('streams');

  return (
    <div className="container-custom py-12 relative">
      {/* Background elements */}
      <div className="absolute inset-0 z-0">
        <div className="absolute top-0 right-0 w-1/3 h-1/3 bg-primary-500/5 rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-1/3 h-1/3 bg-secondary-500/5 rounded-full filter blur-3xl"></div>
      </div>

      <motion.div 
        className="relative z-10"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div className="mb-8">
          <h1 className="text-4xl font-bold mb-4 text-shadow">Explore</h1>
          <p className="text-xl text-gray-400 max-w-3xl">
            Discover the latest streams, NFTs, and drops from creators around the world
          </p>
        </div>

        {/* Tabs */}
        <div className="flex space-x-2 border-b border-dark-700 mb-8 overflow-x-auto pb-2">
          <motion.button
            onClick={() => setActiveTab('streams')}
            className={`px-4 py-2 font-medium rounded-t-lg flex items-center space-x-2 transition-all duration-300 ${
              activeTab === 'streams'
                ? 'text-primary-500 border-b-2 border-primary-500 bg-dark-800/50 backdrop-blur-sm'
                : 'text-gray-400 hover:text-white hover:bg-dark-800/30'
            }`}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <FiVideo className="w-5 h-5" />
            <span>Live Streams</span>
          </motion.button>
          <motion.button
            onClick={() => setActiveTab('nfts')}
            className={`px-4 py-2 font-medium rounded-t-lg flex items-center space-x-2 transition-all duration-300 ${
              activeTab === 'nfts'
                ? 'text-primary-500 border-b-2 border-primary-500 bg-dark-800/50 backdrop-blur-sm'
                : 'text-gray-400 hover:text-white hover:bg-dark-800/30'
            }`}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <FiImage className="w-5 h-5" />
            <span>NFTs</span>
          </motion.button>
          <motion.button
            onClick={() => setActiveTab('drops')}
            className={`px-4 py-2 font-medium rounded-t-lg flex items-center space-x-2 transition-all duration-300 ${
              activeTab === 'drops'
                ? 'text-primary-500 border-b-2 border-primary-500 bg-dark-800/50 backdrop-blur-sm'
                : 'text-gray-400 hover:text-white hover:bg-dark-800/30'
            }`}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <FiPackage className="w-5 h-5" />
            <span>Drops</span>
          </motion.button>
        </div>

        {/* Content */}
        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
          >
            {activeTab === 'streams' && (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {demoStreams.map((stream, index) => (
                  <motion.div
                    key={stream.id}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3, delay: index * 0.1 }}
                  >
                    <StreamCard stream={stream} />
                  </motion.div>
                ))}
              </div>
            )}

            {activeTab === 'nfts' && (
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                {demoNfts.map((nft, index) => (
                  <motion.div
                    key={nft.id}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3, delay: index * 0.1 }}
                  >
                    <NFTCard nft={nft} />
                  </motion.div>
                ))}
              </div>
            )}

            {activeTab === 'drops' && (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {demoDrops.map((drop, index) => (
                  <motion.div
                    key={drop.id}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3, delay: index * 0.1 }}
                  >
                    <DropCard drop={drop} />
                  </motion.div>
                ))}
              </div>
            )}
          </motion.div>
        </AnimatePresence>
      </motion.div>
    </div>
  );
}
